const sdkUrlList = [
    {
        BASEURL: 'http://192.168.68.106:8081/sdkDialog/#/main',
    },
    {
        BASEURL: 'https://game.tian-xsy.com/sdkDialog/#/main',
    },
];

let sdkUrlArr;

sdkUrlArr = sdkUrlList[1]
let sdkUrl = sdkUrlArr.BASEURL
export default sdkUrl
